/**
 * Stops the execution of the function for the specified number of `ms`
 *
 * @example
 * const exampleFn = async () => {
 *    const DURATION = 5 // s
 *    const SECOND = 1000 // ms
 *
 *    console.log(`Waiting ${DURATION} seconds...`)
 *    await wait(DURATION * SECOND)
 *
 *    console.log('Done')
 * }
 */
export const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
